export const selectHomeSearchAuthModalVisible = state =>
  state.homeSearchAuthModal.visible
